module.exports = __webpack_public_path__ + "static/media/avatars.4b83c502.svg";